import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    signedIn: false,
    userResponse: null
  },
  mutations: {
    updateUserResponse(state, payload) {
      state.userResponse = payload;
    },
    signIn(state) {
      state.signedIn = true
    }
  },
  actions: {
    fetchNews({commit}, payload) {
      commit('updateValue', payload);
    }
  },
  modules: {
  }
})
